export const GamePromotionType = {
  PROMOTE: 'promote',
  EXCLUDE: 'exclude',
} as const;

export const GamePromotionSubType = {
  PROVIDER: 'provider',
  GAME: 'game',
} as const;

export const GAME_PROMOTION_ALL_COUNTRIES = '_default_';

export const GAME_PROMOTION_KEY_DIVIDER = '***';
